import { render, staticRenderFns } from "./CreateOVEView.vue?vue&type=template&id=04521687&scoped=true&lang=pug"
import script from "./CreateOVEView.vue?vue&type=script&lang=js"
export * from "./CreateOVEView.vue?vue&type=script&lang=js"
import style0 from "./CreateOVEView.vue?vue&type=style&index=0&id=04521687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04521687",
  null
  
)

export default component.exports